import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parse } from 'query-string';
import Form from 'comps/form';
import { CopyButton } from 'comps';
import { Button, Separator, Text } from '@cuemath/comps';
import { sourceValues, OPTIONS } from 'constants/form';
import { COUNTRY_OPTIONS } from 'constants/country-code-map';
import { COLORS } from '@cuemath/comps';
import { store } from 'redux-rest-reducer';

const IS_AMBASSADOR = 'is_ambassador';
const FORM = [
  {
    label: 'First Name',
    id: 'firstName',
    maxLength: '50',
    type: 'text',
  },
  {
    label: 'Last Name',
    id: 'lastName',
    maxLength: '50',
    type: 'text',
  },
  {
    label: 'Country Code',
    id: 'countryCode',
    type: 'text',
  },
  {
    label: 'Primary Number',
    id: 'phone',
    type: 'tel',
  },
  {
    label: 'Email',
    id: 'email',
    type: 'email',
  },
  {
    id: 'ambassador_checkbox',
    name: 'ambassador_checkbox',
    label: 'Select the option below',
    type: 'checkbox',
    options: [{ id: IS_AMBASSADOR, value: 'Ambassador' }],
    feedbackType: 'widget',
  },
];

const REFERRAL_FORM = [
  {
    label: 'Referrer Country Code',
    id: OPTIONS.REFERRER_COUNTRY_CODE,
    type: 'dropdown',
    options: COUNTRY_OPTIONS,
  },
  {
    label: 'Referrer Primary Number',
    id: OPTIONS.REFERRER_PHONE,
    type: 'tel',
  },
];

export default class AddParentForm extends Component {
  constructor(props) {
    super(props);
    const { parentData, primaryNumber } = props;
    const { is_ambassador: isAmbassador } = parentData || {};
    const { first_name: firstName, last_name: lastName, email, phone } =
      parentData.leads[0] || {};
    const disables = { phone: true, countryCode: true };

    if (parentData.leads[0]) {
      FORM.forEach(f => {
        disables[f.id] = true;
      });
    }

    this.state = {
      form: {
        firstName,
        lastName,
        email,
        countryCode: parse(window.location.search).countryCode,
        phone: phone || primaryNumber || parse(window.location.search).phone,
        referrerCountryCode: undefined,
        referrerPhone: undefined,
        ambassador_checkbox: isAmbassador ? [IS_AMBASSADOR] : [],
      },
      validation: {},
      error: {},
      disables,
      msgToDisplay: { success: '', error: '' },
      isStale: false,
      isLoading: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { patchParentResponse, refreshData } = props;
    const { isStale } = state;
    const { resolved: patchParentResponseResolved } = patchParentResponse || {};
    const { isPatched: parentIsPatched, isPatchingFailed: parentIsPatchingFailed } =
      patchParentResponseResolved || {};
    if (parentIsPatchingFailed && !isStale) {
      const error = store.getError(patchParentResponseResolved);
      const { message } = error || {};
      return {
        msgToDisplay: { success: '', error: message || 'Something went wrong.' },
        isStale: true,
        isLoading: false,
      };
    }
    if (parentIsPatched && !isStale) {
      AddParentForm.timeout = setTimeout(() => {
        refreshData();
      }, 1000);

      return {
        msgToDisplay: { success: 'Successfully updated.', error: '' },
        isStale: true,
        isLoading: false,
      };
    }

    return null;
  }

  componentWillUnmount() {
    clearTimeout(AddParentForm.timeout);
  }

  nonOptinalField(k, form) {
    return !form[k];
  }

  onSubmit = () => {
    const { postParent, postParentResponse } = this.props;
    const {
      form: { firstName, lastName, email, phone, countryCode, ambassador_checkbox },
    } = this.state;

    const payload = {
      name: `${firstName} ${lastName}`,
      phone,
      email,
      country_code: countryCode,
      is_ambassador: ambassador_checkbox?.includes(IS_AMBASSADOR) ? true : false,
    };

    if (postParentResponse && postParentResponse.isCreating) {
      return;
    }

    postParent(postParentResponse.id, payload);
  };

  onFormChange = (nextData, nextValidation) => {
    const formData = {};

    Object.keys(nextData).forEach(k => {
      formData[k] = (nextData[k].target && nextData[k].target.value) || nextData[k];
    });

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        ...formData,
      },
      validation: {
        ...prevState.validation,
        ...nextValidation,
      },
      msgToDisplay: { success: '', error: '' },
      error: {},
    }));
  };

  addReferral = () => {
    const { form, disables } = this.state;
    this.setState({
      form: {
        ...form,
        source: { label: 'Referral', value: 'Referral' },
      },
      disables: { ...disables, source: true },
    });
  };

  onSave = () => {
    const { patchParent, patchParentResponse, parentData } = this.props;
    const { form, isLoading } = this.state;
    const { parent_id: parentId } = parentData || {};
    const { ambassador_checkbox, source = '', referrerPhone, referrerCountryCode } =
      form || {};
    const { value: countryCode } = referrerCountryCode || {};
    const validateReferral = source.value === sourceValues.PARENT_REFERRAL;
    let payload = {
      is_ambassador: ambassador_checkbox?.includes(IS_AMBASSADOR) ? true : false,
    };

    if (validateReferral) {
      payload = {
        ...payload,
        referrer_phone: referrerPhone,
        referrer_country_code: countryCode,
        action_source: 'LA_REF',
      };
    }

    if (patchParentResponse && patchParentResponse.isPatching) {
      return;
    }
    if (isLoading) {
      return;
    }

    this.setState({ isStale: false, isLoading: true });
    patchParent(patchParentResponse.id, parentId, payload);
  };

  getDisabledState = () => {
    const { parentData } = this.props;
    const { is_ambassador: isAmbassador } = parentData || {};
    const { form } = this.state;
    const { ambassador_checkbox, source = '', referrerCountryCode, referrerPhone } =
      form || {};
    const { value: countryCode } = referrerCountryCode || {};

    const referrerForm = {
      referrerPhone: referrerPhone,
      referrerCountryCode: countryCode,
    };

    const notFilled = Object.keys(referrerForm).filter(k => {
      return this.nonOptinalField(k, form);
    });

    const validateReferral = source.value === sourceValues.PARENT_REFERRAL;
    const checkboxSelected = ambassador_checkbox?.includes(IS_AMBASSADOR);
    if (!validateReferral) {
      if (isAmbassador === checkboxSelected) {
        return true;
      }

      return false;
    } else {
      if (isAmbassador === checkboxSelected && notFilled.length) {
        return true;
      }
      return false;
    }
  };

  render() {
    const { form, validation, error, disables, msgToDisplay, isLoading } = this.state;
    const { parentData = {} } = this.props;
    const { leads = {}, referral_link: referralLink } = parentData || {};
    const { source = '' } = form;
    const validateReferral = source.value === sourceValues.PARENT_REFERRAL;
    const { success: successMsg, error: errorMsg } = msgToDisplay || {};
    const disabled = this.getDisabledState();

    return (
      <div>
        <Text size="large" weight="bolder">
          Parent Details
        </Text>
        <Form
          nodes={FORM}
          values={form}
          validations={validation}
          disables={disables}
          error={error}
          onChange={this.onFormChange}
        />
        {referralLink && (
          <>
            <Text size="medium" weight="bolder">
              Referral Link:{' '}
            </Text>
            <CopyButton text={referralLink} copyMessage="Copy" />
          </>
        )}
        <Separator transparent height={15} />
        {!validateReferral && (
          <Button
            label="Save"
            onClick={this.onSave}
            busy={isLoading}
            disabled={disabled}
          />
        )}
        <Separator height={8} transparent />
        {validateReferral && (
          <>
            <Text size="large" weight="bolder">
              Referrer Details
            </Text>
            <Form
              nodes={REFERRAL_FORM}
              values={form}
              validations={validation}
              disables={disables}
              error={error}
              onChange={this.onFormChange}
            />
            <Separator height={8} transparent />
          </>
        )}
        {validateReferral ? (
          <Button
            label="Save"
            onClick={this.onSave}
            busy={isLoading}
            disabled={disabled}
          />
        ) : (
          <Button label="Update Referrer Details" onClick={this.addReferral} />
        )}

        <Separator height={8} transparent />
        {successMsg && (
          <Text color={COLORS.DARK_GREEN} size="medium" weight="bolder">
            {successMsg}
          </Text>
        )}
        {errorMsg && (
          <Text color={COLORS.RED} size="medium" weight="bolder">
            {errorMsg}
          </Text>
        )}
        {parentData && leads.length === 0 && (
          <Button onClick={this.onSubmit} label="Next" />
        )}
      </div>
    );
  }
}

AddParentForm.defaultProps = {
  primaryNumber: '',
};

AddParentForm.propTypes = {
  postParent: PropTypes.func.isRequired,
  parentData: PropTypes.shape({}).isRequired,
  primaryNumber: PropTypes.string,
  postParentResponse: PropTypes.shape({}).isRequired,
};
